import { render, staticRenderFns } from "./EngineLoadProfileRPMMotorList.vue?vue&type=template&id=5b0fb44e&scoped=true&"
import script from "./EngineLoadProfileRPMMotorList.vue?vue&type=script&lang=ts&"
export * from "./EngineLoadProfileRPMMotorList.vue?vue&type=script&lang=ts&"
import style0 from "./EngineLoadProfileRPMMotorList.vue?vue&type=style&index=0&id=5b0fb44e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0fb44e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
